export enum SortDirection {
  Asc = 1,
  Desc = 2,
}

export namespace SortDirection {
  export const mapToApiValue = (sortDirection: SortDirection | null): string => {
    switch (sortDirection) {
      case SortDirection.Asc:
        return 'ASC';
      case SortDirection.Desc:
        return 'DESC';
      default:
        return '';
    }
  };

  export const toggle = (sortDirection: SortDirection | null): SortDirection | null => {
    switch (sortDirection) {
      case SortDirection.Desc:
        return SortDirection.Asc;
      case SortDirection.Asc:
        return null;
      default:
        return SortDirection.Desc;
    }
  };
}
